<article class="side-search-container">
  <h2>Sök bland alla bokningar</h2>
  <!-- Searchbox -->
  <section class="side-searchbox-wrapper {{termTooShort ? 'term-too-short': null}}">
    <input type="search" placeholder="Reg.nr/bokningsnr." [formControl]="searchInput" #searchBox
      data-test="side-menu-search" (input)="search(searchInput.value || undefined)" spellcheck="false"
      autocomplete="off">
    </section>

    <div class="side-search-result-wrapper">
      <!-- Search result upcoming -->
      @if (searchResultUpcoming && !termNotFound) {
        <div class="search-result-section">
          <p>Kommande bokningar</p>
          <app-bookings-table
            [bookings]="searchResultUpcoming"
            [sortOrder]="upcomingSortOrder"
            [prevTargetColumn]="upcomingPrevColumn"
            [compactCommentsHeader]="true"
            [compactPassengersHeader]="true"
            [wideArrivalDateColumn]="true"
            (sortColumnClick)="onSort('upcoming', $event)"
            (closeDrawer)="close()"
          ></app-bookings-table>
        </div>
      }

      <!-- Search result old -->
      @if (searchResultHistory && !termNotFound) {
        <div class="search-result-section">
          <p>Historiska bokningar</p>
          <app-bookings-table
            [bookings]="searchResultHistory"
            [sortOrder]="historySortOrder"
            [prevTargetColumn]="historyPrevColumn"
            [compactCommentsHeader]="true"
            [compactPassengersHeader]="true"
            [wideArrivalDateColumn]="true"
            (sortColumnClick)="onSort('history', $event)"
            (closeDrawer)="close()"
          ></app-bookings-table>
        </div>
      }

      <!-- Booking not found -->
      @if (!searchResultHistory && !searchResultUpcoming) {
        <div class="empty-content">
          @if (termNotFound) {
            <p>Kunde inte hitta en bokning med "{{termNotFound}}"</p>
          }
          @if (!termNotFound) {
            <p>Sök på registrerings- eller bokningsnummer</p>
          }
        </div>
      }

      @if (showSpinner) {
        <div class="spinner-wrapper">
          <mat-spinner></mat-spinner>
        </div>
      }
    </div>
  </article>